// Supported feature names for the type FEATURE_CHANGED in the event log
// When adding more features, replace EACH number in the feature name with an 'X'
export const supportedFeatureNames: string[] = [
  'ems.control.vcs.X.charging.mode',
  'heating.configuration.cooling',
  'ventilation.bypass.operating.modes.active',
  'heating.dhw.operating.modes.active',
  'heating.dhw.schedule.mode',
  'fuelCell.operating.modes.active',
  'ventilation.operating.modes.active',
  'heating.buffer.operating.modes.active',
  'heating.secondaryHeatGenerator.operating.modes.active',
  'heating.configuration.secondaryHeatGenerator.modeOnError',
  'heating.circuits.X.operating.modes.active',
  'heating.smartGrid.regulation',
  'trv.temperature',
  'heating.dhw.temperature.main',
  'heating.dhw.temperature.tempX',
  'heating.increasedReturn.temperature',
  'heating.configuration.buffer.temperature.max',
  'heating.configuration.flow.temperature.max',
  'heating.configuration.flow.temperature.min',
  'heating.dhw.configuration.temperature.comfortCharging',
  'heating.configuration.dhw.temperature.hotWaterStorage.max',
  'heating.dhw.configuration.temperature.dhwCylinder.max',
  'heating.dhw.temperature.hygiene',
  'hdc.heating.circuits.X',
  'heating.callForHeat.temperature',
  'heating.circuits.X.operating.programs.manual',
  'heating.circuits.X.operating.programs.comfort',
  'heating.circuits.X.operating.programs.comfortCooling',
  'heating.circuits.X.operating.programs.normalCooling',
  'heating.circuits.X.operating.programs.reducedCooling',
  'heating.circuits.X.operating.programs.comfortHeating',
  'heating.circuits.X.operating.programs.normalHeating',
  'heating.circuits.X.operating.programs.reducedHeating',
  'heating.circuits.X.operating.programs.normal',
  'heating.circuits.X.operating.programs.reduced',
  'heating.temperature.commonSupply',
  'rooms.X.operating.programs.normal',
  'rooms.X.operating.programs.normalHeating',
  'rooms.others.X.operating.programs.normal',
  'rooms.others.X.operating.programs.normalCooling',
  'rooms.X.operating.programs.normalCooling',
  'rooms.others.X.operating.programs.normalHeating',
  'rooms.X.operating.programs.reducedHeating',
  'rooms.others.X.operating.programs.reducedHeating',
  'rooms.X.operating.programs.comfortCooling',
  'rooms.X.operating.programs.comfortHeating',
  'rooms.others.X.operating.programs.comfortCooling',
  'rooms.others.X.operating.programs.comfortHeating',
  'rooms.X.operating.programs.reduced',
  'rooms.X.operating.programs.reducedCooling',
  'rooms.others.X.operating.programs.reducedCooling',
  'rooms.others.X.operating.programs.reduced',
  'rooms.X.operating.programs.comfort',
  'rooms.others.X.operating.programs.comfort',
  'rooms.X.operating.programs.manualTillNextSchedule',
  'rooms.X.operating.programs.manualTillNextScheduleHeating',
  'rooms.X.operating.programs.manualTillNextScheduleCooling',
  'rooms.others.X.operating.programs.manualTillNextSchedule',
  'rooms.others.X.operating.programs.manualTillNextScheduleHeating',
  'rooms.others.X.operating.programs.manualTillNextScheduleCooling',
  'rooms.X.quickmodes.manual',
  'rooms.X.quickmodes.manualTillNextSchedule',
  'rooms.others.X.quickmodes.manual',
  'rooms.X.temperature.levels.reduced.perceived',
  'rooms.X.temperature.levels.comfort.perceived',
  'rooms.X.temperature.levels.normal.perceived',
  'rooms.others.X.temperature.levels.reduced.perceived',
  'rooms.others.X.temperature.levels.comfort.perceived',
  'rooms.others.X.temperature.levels.normal.perceived',
  'rooms.others.X.quickmodes.manualTillNextSchedule',
  'heating.circuits.X.operating.programs.ttContact',
  'heating.secondaryHeatGenerator.configuration.buffer',
  'rooms.X.operating.programs.manual',
  'rooms.others.X.operating.programs.manual',
  'rooms.X.operating.programs.manualCooling',
  'rooms.others.X.operating.programs.manualCooling',
  'rooms.X.operating.programs.manualHeating',
  'rooms.others.X.operating.programs.manualHeating',
  'heating.circuits.X.dhw.pumps.circulation.schedule',
  'heating.circuits.X.heating.schedule',
  'heating.circuits.X.dhw.schedule',
  'ventilation.schedule',
  'rooms.X.schedule',
  'rooms.others.X.schedule',
  'heating.secondaryHeatGenerator.electricity.price.schedule',
  'heating.noise.reduction.schedule',
  'heating.dhw.pumps.circulation.schedule',
  'heating.dhw.schedule',
  'fht.valve',
  'rooms.X',
  'rooms.others.X',
  'ess.configuration.backupBox',
  'heating.cascade.temperature.commonSupply',
  'heating.circuits.X.heating.roomInfluenceFactor',
  'vcs.control.charging.limit.base',
  'heating.compressors.X.power',
  'heating.device.time.source',
  'heating.configuration.bufferCylinderSize',
  'heating.configuration.centralHeatingCylinderSize',
  'heating.configuration.dhwCylinderSize',
  'heating.configuration.houseHeatingLoad',
  'heating.dhw.configuration.highDemand.timeframe',
  'heating.dhw.configuration.highDemand.threshold',
  'rooms.remotePresenceProbability',
  'fht.configuration.demandRelayMode',
  'ems.grid.current.limit',
  'rooms.X.configuration.trvAlgorithmActive',
  'rooms.X.configuration.hydraulicBalancing',
  'fht.configuration.floorHeatingDamageProtectionThreshold',
  'rooms.X.configuration.heatUpSpeed',
  'heating.configuration.smartGrid.signalSource',
  'heating.dhw.configuration.sensors.ecoMode.leading',
  'heating.solar.forecast.surfaceNetIrradiance',
  'rooms.status',
  'ms.features.heatOnTime',
  'rooms.features.remotePresenceProbability',
  'rooms.X.configuration.openWindow',
  'fht.valve.burnInMode',
  'hbX.veryLongComfortMode',
  'heating.secondaryHeatGenerator.configuration.heating.comfortEnsuring',
  'heating.secondaryHeatGenerator.configuration.screedDrying',
  'heating.dhw.hygiene',
  'heating.device.emergencyOperation',
  'heating.dhw.oneTimeCharge',
  'tcu.features.lanOne',
  'tcu.features.lanTwo',
  'heating.circuits.X.configuration.summerEco.absolute',
  'ventilation.quickmodes.comfort',
  'device.zigbee.active',
  'ventilation.operating.programs.comfort',
  'ventilation.operating.programs.eco',
  'ventilation.quickmodes.eco',
  'ventilation.operating.programs.forcedLevelFour',
  'ventilation.operating.programs.permanent',
  'ventilation.operating.programs.silent',
  'ventilation.quickmodes.silent',
  'ventilation.quickmodes.forcedLevelFour',
  'water.valves.shutoff.holiday',
  'heating.burners.X.manualActivation',
  'heating.outdoor.defrosting',
  'hdc',
  'heating.noise.reduction',
  'heating.secondaryHeatGenerator.configuration.defrosting',
  'heating.secondaryHeatGenerator.configuration.dhw',
  'heating.secondaryHeatGenerator.configuration.dhw.comfortEnsuring',
  'heating.secondaryHeatGenerator.configuration.frostprotection',
  'heating.secondaryHeatGenerator.configuration.refrigerationCircuitExceeded',
  'heating.circuits.X.operating.programs.screedDrying',
  'ems.hoca.features.photovoltaicExcessToHeatpump',
  'ems.hoca.features.vcsOverloadProtection',
  'ems.hoca.features.forecastBasedBatteryOperation',
  'ems.hoca.features.onlineSolarIrradianceForecast',
  'heating.circuits.X.operating.programs.eco',
  'heating.secondaryHeatGenerator.configuration.heating',
  'heating.secondaryHeatGenerator.configuration.hygiene',
  'ventilation.quickmodes.standby',
  'heating.circuits.X.operating.programs.forcedLastFromSchedule',
  'rooms.X.childLock',
  'ventilation.features.temperatureHumidity',
  'ventilation.features.organicComponent',
  'ventilation.features.dust',
  'ventilation.features.coX',
  'ventilation.features.co',
  'ventilation.features.finedust',
  'ventilation.control.filterChange',
  'heating.circuits.X.operating.programs.holiday',
  'ventilation.quickmodes.holiday',
  'heating.circuits.X.operating.programs.holidayAtHome',
  'ventilation.operating.programs.holiday',
  'ventilation.operating.programs.holidayAtHome',
  'heating.operating.programs.holiday',
  'heating.operating.programs.holidayAtHome',
  'gateway.firmware',
  'gateway.firmware.legacy', // feature does not exist, it is required to handle exception in translateFeatureName
];

export enum supportedFeatureCommands {
  SET_MODE = 'SET_MODE',
  SET_TARGET_TEMPERATURE = 'SET_TARGET_TEMPERATURE',
  SET_TEMPERATURE = 'SET_TEMPERATURE',
  SET_SCHEDULE = 'SET_SCHEDULE',
  SET_TYPE = 'SET_TYPE',
  SET_VALUE = 'SET_VALUE',
  ACTIVATE = 'ACTIVATE',
  DEACTIVATE = 'DEACTIVATE',
  REMOVE = 'REMOVE',
  SCHEDULE = 'SCHEDULE',
  UNSCHEDULE = 'UNSCHEDULE',
  UPDATE = 'UPDATE',
}
